var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-card",
        {
          staticClass: "hidden-md-and-up",
          staticStyle: { padding: "0 !important", width: "100%" },
          attrs: { flat: "" }
        },
        [
          _c(
            "v-container",
            { staticStyle: { padding: "0 !important" }, attrs: { fluid: "" } },
            [
              _c("v-layout", { attrs: { row: "" } }, [
                _c(
                  "div",
                  { staticStyle: { width: "100vw" } },
                  [
                    _c(
                      "v-toolbar",
                      {
                        staticStyle: {
                          "background-color": "#2562af !important",
                          "border-top-left-radius": "10px !important",
                          "border-top-right-radius": "10px !important",
                          "box-shadow": "0 0 black !important",
                          height: "30px !important"
                        }
                      },
                      [
                        _c("v-toolbar-title", { staticClass: "ml-0 pl-0" }),
                        _vm._v(" "),
                        _c("v-spacer")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ab9446f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab9446f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/LayoutHeader.vue
// module id = null
// module chunks = 